import React from 'react';
import { Button } from '@/components/ui/button';
import { ShieldCheck, ShieldOff, Lock } from 'lucide-react';

export default function SecurityIdleStep({ user, onEnable2FA, onDisable2FA, onChangePassword, processing }) {
  const enabled = !!user?.twofa_enabled;
  return (
    <div className="space-y-4 mt-4">
      <div className="p-4 rounded-lg bg-muted">
        <div className="flex items-center gap-3">
          {enabled ? (
            <ShieldCheck className="w-8 h-8 text-green-600" />
          ) : (
            <ShieldOff className="w-8 h-8 text-muted-foreground" />
          )}
          <div>
            <div className="font-medium">
              {enabled ? '2FA is enabled' : '2FA is disabled'}
            </div>
            <div className="text-sm text-muted-foreground">
              {enabled
                ? 'Your account is protected with an authenticator app.'
                : 'Add a second layer of security using an authenticator app.'}
            </div>
          </div>
        </div>
      </div>
      {enabled ? (
        <Button data-testid="disable-2fa-btn" onClick={onDisable2FA} variant="outline" className="w-full rounded-full text-destructive border-destructive">
          Disable 2FA
        </Button>
      ) : (
        <Button data-testid="enable-2fa-btn" onClick={onEnable2FA} disabled={processing} className="w-full rounded-full bg-primary hover:bg-primary/90 text-primary-foreground">
          <ShieldCheck className="w-4 h-4 mr-2" />Enable 2FA
        </Button>
      )}
      <Button
        data-testid="open-change-password-btn"
        onClick={onChangePassword}
        variant="outline"
        className="w-full rounded-full"
      >
        <Lock className="w-4 h-4 mr-2" /> Change Password
      </Button>
    </div>
  );
}
